import { FileStarIcon } from './FileStarIcon';

/**
 * author: Michael Irigoyen
 * id E7E04B34-BC51-466F-92A1-78C8A00DDC9D
 * name file-star
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-star.svg
 * tags
 * - Files / Folders 
 */
export const FileFavoriteIcon = FileStarIcon;
export default FileFavoriteIcon